/**
 * Letting a screen take the next scan.
 *
 * `app.tsx` reads the scanner once, for the whole page, and decides what a scan
 * is by its shape alone: digits are a product, anything else is a staff badge.
 * A coupon is neither, so a customer holding one up to the scanner on the
 * payment screen got nothing — the scan was read as a badge and dropped, and
 * the coupon sheet draws its own keys rather than a field the scanner could
 * type into.
 *
 * So a screen that is waiting for a code says so. One claimant at a time: the
 * latest wins, and releasing only clears what is still its own, so a screen
 * unmounting late cannot take the claim away from the one that replaced it.
 * A claimant returns `false` for a code it does not want, and the scan goes on
 * to be a product or a badge as before.
 */
type Claimant = (code: string) => boolean

let claimant: Claimant | null = null

export function claimScans(handler: Claimant): () => void {
  claimant = handler
  return () => {
    if (claimant === handler) claimant = null
  }
}

/** True when a screen took the scan, and nothing else should act on it. */
export function offerScan(code: string): boolean {
  return claimant?.(code) ?? false
}
